import { AttachmentModel } from './../AddRequest/AttachmentModel';

import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

import ValidationService from '../../Services/ValidationService';

import WithRender from './MessageTemplateReqeust.html';

import { Inject } from 'vue-di-container';

import MessageTemplateService from './MessageTemplateService';

import { Toaster } from '../../Services/toast';

import { DropdownModel } from '../Provider/ProviderModel';
import { isolateTemplateVariablePlaceholders } from '../../shared/templateTextDirection';

import { SenderType } from '../../shared/Enums/SenderType';
import { AttachmentCategoryType } from '../../shared/Enums/AttachmentCategory';
import { TemplateVariableValidation } from '../../shared/templateVariableValidation';

import CITCKeywordsService from '../CITCKeywords/CITCKeywordsService';

import ProviderService from '../Provider/ProviderService';
import UserService from '../../shared/userService/UserService';
import { ProviderModel } from '../Provider/ProviderModel';
import VirtualOperatorRules from '@/shared/VirtualOperatorRules';

import { MessageTemplateModel, SenderViewModel, SuggestedTemplateModel, TemplateValidationModel } from './MessageTemplateModel';

import { AxiosError } from 'axios';



@WithRender

@Component({

    components: {

    },

    diProvide: [
        MessageTemplateService,
        CITCKeywordsService,
        ProviderService,
    ],

})

export default class MessageTemplateReqeust extends Vue {

    @Inject(ValidationService) public validationService!: ValidationService;

    @Inject(MessageTemplateService) public connectingSenderNameService!: MessageTemplateService;

    @Inject(CITCKeywordsService) public cITCKeywordsService!: CITCKeywordsService;

    @Inject(ProviderService) public providerService!: ProviderService;
    @Inject(MessageTemplateService) public messageTemplateService!: MessageTemplateService;

    @Inject(UserService) public userService!: UserService;

    @Prop({ type: Boolean, default: false })



    public layoutSup: boolean | any;

    public stepNumber: number = 1;

    public provider: ProviderModel = {
        id: '',
        providerCode: '',
        name: '',
        createdDate: null,
        enterpriseUnifiedNumber: '',
        accreditationNumber: '',
        email: '',
        taxNumber: '',
        hasInternational: false,
        country: '',
        city: '',
        district: '',
        streetName: '',
        buildingNumber: '',
        postalCode: '',
        vatNumber: '',
        additionalNumber: '',
        otherIdentifier: '',
        creditLimitAmount: 0,
        balance: 0,
        bankAccountNumber: '',
        expireDate: '',
        state: '',
        isDisconnected: '',
        integrationBaseURL: '',
        isVirtualOperator: false,
        virtualOperatorId: null,
        virtualOperatorName: '',
    };

    public senderNameFilter: string = '';

    public typeFile: number = 0;

    public submitRequestdialog: boolean = false;
    public isSubmitted: boolean = false;
    public isVipPackage: boolean = false;
    public templateVariableExamples: string[] = [];
    public templateVariableMaxLengths: number[] = [];
    public templateVariableTypes: string[] = [];
    public readonly validVariableTypes: string[] = ['Numbers', 'Letters', 'Letters & Numbers', 'Link'];
    private lastValidatedTemplateContent: string = '';
    private lastEditableTemplateContent: string = '';
    private lastAiFailureRemarks: string = '';
    private isTemplateContentMutationAllowed: boolean = false;
    public selectedFileName: string = '';
    public currentAttachment: AttachmentModel = {
        id: '',
        fileName: '',
        fileContent: '',
        file: null,
        attachmentType: '',
        attachmentTypeName: '',
        isDeleted: false,
    };

    public readonly maxLicenseAttachments: number = 3;
    public readonly maxLicenseFileSizeBytes: number = 3000000;
    public readonly totalSteps: number = 3;
    public loadingAIValidation: boolean = false;
    public aiValidationProgress: number = 0;
    private aiValidationProgressInterval: any = null;
    public aiContinueDialog: boolean = false;
    public templateTextDir: string = (typeof localStorage !== 'undefined' && localStorage.dir === 'rtl') ? 'rtl' : 'ltr';

    public setTemplateTextDir(dir: string): void {
        this.templateTextDir = dir === 'rtl' ? 'rtl' : 'ltr';
    }



    public headers: any = [

        { text: this.$t('shared.senderName'), value: 'operatorId', align: 'center', sortable: false },

        { text: this.$t('shared.senderType'), value: 'operatorId', align: 'center', sortable: false },

        { text: this.$t('shared.clientName'), value: 'name', align: 'center', sortable: false }

    ];



    public customerTypeList: DropdownModel[] = [

        { id: 1, name: this.$t('shared.government').toString() },

        { id: 2, name: this.$t('shared.charity').toString() },

        { id: 3, name: this.$t('shared.private').toString() },

        { id: 4, name: this.$t('shared.international').toString() },

    ];



    public allClassifications: DropdownModel[] = [
        { id: 1, name: this.$t('shared.Advertising').toString() },
        { id: 2, name: this.$t('shared.Service').toString() },
        { id: 3, name: this.$t('shared.Warning').toString() },
        { id: 5, name: this.$t('shared.Awareness').toString() },
    ];

    private readonly classificationBySenderType: { [key: number]: number[] } = {
        [SenderType.Advertisement]: [1],
        [SenderType.Service]: [2],
        [SenderType.Awareness]: [5],
        [SenderType.Warning]: [3],
    };



    public senderTypeList: DropdownModel[] = [

        { id: SenderType.Advertisement, name: this.$t('shared.advertisement').toString() },

        { id: SenderType.Service, name: this.$t('shared.service').toString() },

        { id: SenderType.Awareness, name: this.$t('shared.awareness').toString() },

        { id: SenderType.Warning, name: this.$t('shared.warning').toString() },

    ];



    public model: MessageTemplateModel = {

        duration: '1',

        startDate: '',

        clientName: '',

        customerType: 0,

        crNumber: '',

        enterpriseUnifiedNumber: '',

        senderNames: [],

        requestType: 7,

        comment: '',

        expiryDate: '',

        templateExpiry: 1,

        templateName: '',

        templateDescription: '',

        templateContent: '',

        isNormalProcessing: true,

        isExpressProcessing: false,

        preApprovedTemplateId: '',

        senderId: '',

        classification: 0,

        senderRequestAttachments: [],
        selectedTemplateId: '',
        senderExpiryDate: '',
        companyName: '',

    };

    public preApprovedTemplates: SuggestedTemplateModel[] = [];
    public loadingPreApprovedTemplates: boolean = false;

    public get filteredSuggestedTemplates(): SuggestedTemplateModel[] {
        if (!this.model.classification) {
            return [];
        }
        return this.preApprovedTemplates;
    }

    public selectedTemplateDescription: string = '';

    public get isDescriptionDisabled(): boolean {
        return this.isSuggestedFreeContentSelected && !!this.selectedTemplateDescription;
    }

    public isSuggestedTemplateSelected(template: SuggestedTemplateModel): boolean {
        return this.isSuggestedFreeContentSelected && this.model.selectedTemplateId === template.id;
    }

    public selectSuggestedTemplate(template: SuggestedTemplateModel) {
        this.model.preApprovedTemplateId = template.id;
        this.model.selectedTemplateId = template.id;
        this.model.templateName = template.name;
        this.selectedTemplateDescription = template.description || '';
        this.model.templateDescription = template.description || '';
        this.model.templateContent = template.content;
        this.syncVariablesFromTemplateContent(template.content, template.variableExamples, template.variableMaxLengths, template.variableTypes);
        this.lastValidatedTemplateContent = this.model.templateContent;
        this.lastEditableTemplateContent = this.model.templateContent;
        this.lastAiFailureRemarks = '';
        this.aiValidationRemarks = '';
        this.resetTemplateCheck();
    }

    public deselectSuggestedTemplate() {
        this.model.preApprovedTemplateId = '';
        this.model.selectedTemplateId = '';
        this.model.templateName = '';
        this.selectedTemplateDescription = '';
        this.model.templateDescription = '';
        this.model.templateContent = '';
        this.templateVariableExamples = [];
        this.templateVariableMaxLengths = [];
        this.templateVariableTypes = [];
        this.lastValidatedTemplateContent = '';
        this.lastEditableTemplateContent = '';
        this.lastAiFailureRemarks = '';
        this.aiValidationRemarks = '';
        this.resetTemplateCheck();
    }

    public toggleSuggestedTemplate(template: SuggestedTemplateModel) {
        if (this.isSuggestedTemplateSelected(template)) {
            this.deselectSuggestedTemplate();
            return;
        }
        this.selectSuggestedTemplate(template);
    }
    private syncVariablesFromTemplateContent(content: string, examples?: string[], maxLengths?: number[], types?: string[]) {
        const matches = [...(content || '').matchAll(/#Var(\d+)#/gi)];
        if (!matches.length) {
            this.templateVariableExamples = [];
            this.templateVariableMaxLengths = [];
            this.templateVariableTypes = [];
            return;
        }
        const maxIndex = Math.max(...matches.map((match) => parseInt(match[1], 10)));
        this.templateVariableExamples = Array.from({ length: maxIndex }, (_, index) => {
            const provided = examples && examples[index];
            if (provided && provided.trim()) {
                return provided.trim();
            }
            return this.getDefaultVariableExampleValue(index + 1);
        });
        this.templateVariableMaxLengths = Array.from({ length: maxIndex }, (_, index) => {
            if (maxLengths && maxLengths[index]) {
                return maxLengths[index];
            }
            const ex = this.templateVariableExamples[index];
            return ex ? ex.length : 0;
        });
        this.templateVariableTypes = Array.from({ length: maxIndex }, (_, index) => {
            const provided = types && types[index];
            if (provided && provided.trim()) {
                return provided.trim();
            }
            // Match addVariable default so hydrated content (e.g. free templates) can enable Next.
            return 'Letters & Numbers';
        });
    }

    private getDefaultVariableExampleValue(index: number): string {
        const defaults: { [key: number]: string } = {
            1: 'Customer',
            2: '123456',
            3: 'support@company.com',
        };
        return defaults[index] || `Var${index}Example`;
    }

    public get areVariableExamplesValid(): boolean {
        if (!this.templateVariableExamples.length) {
            return true;
        }
        return this.templateVariableExamples.every((value) => value && value.trim() !== '');
    }

    public validationModel: TemplateValidationModel = {

        TemplateContent: '',

        Classification: 0

    };



    public allSenderNames: SenderViewModel[] = [];

    public selected: SenderViewModel[] = [];

    public selectedIds: string[] = [];

    public responseMessage: string = '';

    public responseSuccess: boolean = false;

    public isAiValid: boolean = false;

    public aiValidationRemarks: string = '';



    private readonly noActiveRegulationMessage: string = 'No active regulation found for this category';
    private readonly templateExpiryExceedsSenderExpiryMessage: string = 'The template expiration date cannot exceed the sender name’s expiration date.';



    public async created() {

        this.$emit('childinit', this.layoutSup);

        const user = await this.userService.getUser();

        const providerId = user.details.ProviderId;

        this.provider = await this.providerService.GetById(providerId);

        if (!this.provider.hasInternational) {

            this.customerTypeList.splice(3, 1);

        }

        VirtualOperatorRules.applyPrivateClientFields(this.model, this.provider, false);

        this.isVipPackage = !!(window.$config && window.$config.messageTemplateVipPackage === true);
    }

    public get fileNameRef(): HTMLInputElement {
        return this.$refs.fileName as HTMLInputElement;
    }

    public get regulationsPdfUrl(): string {
        const url = (window.$config && window.$config.messageTemplateRegulationsPdfUrl) || '';
        if (!url) {
            return '';
        }
        if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith('/')) {
            return url;
        }
        return '/' + url.replace(/^\/+/, '');
    }

    public openRegulationsPdf(event?: Event) {
        if (event) {
            event.preventDefault();
        }
        const url = this.regulationsPdfUrl;
        if (!url) {
            return;
        }
        window.open(url, '_blank', 'noopener,noreferrer');
    }



    public get attachmentTooltip(): string {
        const pdfOnly = this.$t('shared.pdfFilesOnly').toString();
        const maxFiles = this.$t('shared.maxLicenseAttachments').toString();
        const max = this.$t('shared.maxFileSize3MB').toString();
        return [pdfOnly, maxFiles, max].join('\n');
    }

    public get canUploadMoreLicenseAttachments(): boolean {
        return this.model.senderRequestAttachments.length < this.maxLicenseAttachments;
    }

    public get canAddAttachment(): boolean {
        return this.canUploadMoreLicenseAttachments && this.selectedFileName !== '';
    }



    public get isAwarenessClassification(): boolean {
        return this.model.classification === 5;
    }

    public get templateSuffix(): string {
        return this.isAwarenessClassification ? (this.model.companyName || '').trim() : '';
    }

    public get displayTemplateSuffix(): string {
        return this.isAwarenessClassification ? this.templateSuffix : '';
    }



    public get filteredClassifications(): DropdownModel[] {

        if (!this.selected.length) {

            return [];

        }

        const allowedIds = new Set<number>();

        this.selected[0].senderTypes.forEach((type) => {

            (this.classificationBySenderType[type] || []).forEach((id) => allowedIds.add(id));

        });

        return this.allClassifications.filter((item) => allowedIds.has(item.id));

    }



    public get isSuggestedFreeContentSelected(): boolean {
        return !!this.model.preApprovedTemplateId;
    }



    public get isTemplateDescriptionValid(): boolean {

        const description = (this.model.templateDescription || '').trim();

        if (!description) {

            return true;

        }

        return description.length >= 3 && description.length <= 160;

    }



    public get templateDescriptionError(): string {

        const description = (this.model.templateDescription || '').trim();

        if (!description) {

            return '';

        }

        if (description.length < 3) {

            return this.$t('shared.templateDescriptionMinLength').toString();

        }

        if (description.length > 160) {

            return this.$t('shared.templateDescriptionMaxLength').toString();

        }

        return '';

    }



    public get activeVariableIndexes(): number[] {

        const matches = [...(this.model.templateContent || '').matchAll(/#Var(\d+)#/gi)];

        const indexes = matches.map((match) => parseInt(match[1], 10));

        return [...new Set(indexes)].sort((a, b) => a - b);

    }



    public get templateContentMinimumCharacterCount(): number {

        return this.templateSuffix.length;

    }

    public get templateContentTotalCharacterCount(): number {

        const fullContent = this.fullTemplateContent;
        const suffixSeparatorLength = this.baseTemplateContent && fullContent !== this.baseTemplateContent ? 1 : 0;

        return this.getTemplateContentWithoutVariables(fullContent).length - suffixSeparatorLength;

    }

    public get hasInvalidVariableBoundary(): boolean {

        return this.contentStartsOrEndsWithVariable(this.model.templateContent);

    }



    public get isTemplateContentDisabled(): boolean {

        return this.isSuggestedFreeContentSelected;

    }



    public get areVariableActionsDisabled(): boolean {

        return this.isSuggestedFreeContentSelected;

    }



    public get isExpressProcessingHidden(): boolean {

        return !window.$config
            || window.$config.messageTemplateSpeedUpApprovalHide !== false;

    }

    public get isPaymentPhaseEnabled(): boolean {
        return !!(window.$config && window.$config.messageTemplatePaymentPhaseEnabled === true);
    }

    public get speedUpFeeAmount(): number {
        return (window.$config && window.$config.messageTemplateSpeedUpFeeAmount) || 10;
    }



    public get fullTemplateContent(): string {

        const base = (this.model.templateContent || '').trim();

        const orgName = this.templateSuffix;

        if (!orgName) {

            return base;

        }

        if (base.toLowerCase().endsWith(orgName.toLowerCase())) {

            return base;

        }

        return base ? `${base} ${orgName}` : orgName;

    }

    public get substitutedFullContent(): string {
        const base = (this.model.templateContent || '').trim();
        let result = base;
        for (let i = 0; i < this.templateVariableExamples.length; i++) {
            const value = this.templateVariableExamples[i];
            if (value && value.trim()) {
                result = result.replace(new RegExp('#Var' + (i + 1) + '#', 'g'), value.trim());
            }
        }
        return result;
    }

    public get baseTemplateContent(): string {
        return (this.model.templateContent || '').trim();
    }

    public get hasTemplateVariables(): boolean {
        return /#Var\d+#/i.test(this.baseTemplateContent);
    }

    public formatTemplateContentForDisplay(content: string): string {
        return isolateTemplateVariablePlaceholders(content || '');
    }

    public get reviewTemplateVariables(): Array<{ key: string, value: string }> {
        return this.templateVariableExamples.map((example, index) => ({
            key: '#Var' + (index + 1) + '#',
            value: example || '',
        }));
    }



    public async next() {

        if (this.loadingAIValidation) {

            return;

        }

        if (this.stepNumber === 1) {

            this.syncSelectedSender();

            if (!this.isTemplateExpiryWithinSenderExpiry()) {
                Toaster.error(this.$t('shared.templateExpiryExceedsSenderExpiry').toString());
                return;
            }

        }

        if (this.stepNumber === 2) {

            if (!this.validateTemplateInfoStep()) {

                return;

            }

            this.prepareTemplateInfoForNextStep();

            if (this.isSuggestedFreeContentSelected) {

                this.isAiValid = true;

                this.aiValidationRemarks = '';

                this.stepNumber = 3;

                return;

            }

            if (!this.isAiValid && this.aiValidationRemarks
                && this.model.templateContent === this.lastValidatedTemplateContent) {
                this.showAiContinueDialog();
                return;
            }

            const passed = await this.runAiValidation();
            if (passed) {
                this.stepNumber = 3;
            }

            return;

        }



        if (this.stepNumber < this.totalSteps) {

            this.stepNumber = this.stepNumber + 1;

        }

    }



    public back() {

        if (this.loadingAIValidation) {

            return;

        }

        if (this.stepNumber === 3 && this.isSuggestedFreeContentSelected) {

            this.stepNumber = 2;

            return;

        }

        if (this.stepNumber === 3) {

            this.resetTemplateCheck();

        }

        this.stepNumber = this.stepNumber - 1;

    }



    public validateTemplateInfoStep(): boolean {

        if (!this.model.templateName.trim()) {

            Toaster.error(this.$t('shared.templateName').toString() + ' is required');

            return false;

        }

        if (!this.isTemplateDescriptionValid) {

            Toaster.error(this.templateDescriptionError);

            return false;

        }

        if (!this.model.classification) {

            Toaster.error(this.$t('shared.classification').toString() + ' is required');

            return false;

        }

        if (this.model.classification === 5 && !(this.model.companyName || '').trim()) {

            Toaster.error(this.$t('shared.companyNameRequired').toString());

            return false;

        }

        if (this.isSuggestedFreeContentSelected && !this.model.selectedTemplateId) {

            Toaster.error(this.$t('shared.selectSuggestedFreeTemplate').toString());

            return false;

        }

        if (!this.areVariableExamplesValid) {

            Toaster.error(this.$t('shared.variableExamplesRequired').toString());

            return false;

        }

        if (!this.isSuggestedFreeContentSelected && !this.model.templateContent.trim()) {

            Toaster.error(this.$t('shared.templateValue').toString() + ' is required');

            return false;

        }

        if (!this.isSuggestedFreeContentSelected
            && this.templateContentTotalCharacterCount < this.templateContentMinimumCharacterCount) {

            Toaster.error(this.$t('shared.templateCharacterCount', {
                count: this.templateContentTotalCharacterCount,
                min: this.templateContentMinimumCharacterCount,
            }).toString());

            return false;

        }

        if (!this.isSuggestedFreeContentSelected && this.hasInvalidVariableBoundary) {

            Toaster.error(this.$t('shared.templateVariableBoundaryInvalid').toString());

            return false;

        }

        if (!this.isSuggestedFreeContentSelected && this.hasTemplateVariables) {
            const errors = this.variableValidationErrors;
            if (errors.length > 0) {
                Toaster.error(errors[0]);
                return false;
            }
        }

        return true;

    }



    private prepareTemplateInfoForNextStep() {

        this.model.expiryDate = this.selectedSender && this.selectedSender.templateExpiryDate ? this.selectedSender.templateExpiryDate : '';

        this.model.isNormalProcessing = !this.model.isExpressProcessing;
    }



    private getTemplateContentWithoutVariables(content: string): string {

        return (content || '').replace(/#Var\d+#/gi, '');

    }

    private extractVariablePlaceholders(content: string): string[] {

        return (content || '').match(/#Var\d+#/gi) || [];

    }

    private contentStartsOrEndsWithVariable(content: string): boolean {

        const trimmed = (content || '').trim();

        if (!trimmed) {

            return false;

        }

        return /^#Var\d+#/i.test(trimmed) || /#Var\d+#$/i.test(trimmed);

    }

    private setTemplateContentWithMutation(content: string): void {

        this.isTemplateContentMutationAllowed = true;

        this.model.templateContent = content;

        this.lastEditableTemplateContent = content;

        this.syncAiRemarksForContentEdit(content);

        this.$nextTick(() => {

            this.isTemplateContentMutationAllowed = false;

        });

    }



    public addVariable() {

        if (this.areVariableActionsDisabled) {

            return;

        }

        if (!this.canUseGovernmentVariableException
            && this.templateVariableExamples.length >= TemplateVariableValidation.maxVariableCount) {
            Toaster.error(this.$t('shared.maxVariableCountExceeded', {
                count: TemplateVariableValidation.maxVariableCount,
            }).toString());
            return;
        }

        const nextIndex = this.templateVariableExamples.length + 1;

        const textarea = this.$refs.templateContent as HTMLTextAreaElement;

        const cursorPos = textarea ? textarea.selectionStart : (this.model.templateContent || '').length;

        const content = this.model.templateContent || '';

        const before = content.substring(0, cursorPos);

        const after = content.substring(cursorPos);

        if (!(before || '').trim()) {
            Toaster.error(this.$t('shared.templateMustNotStartOrEndWithVariable').toString());
            return;
        }

        if (/#Var\d+#\s*$/.test(before) || /^\s*#Var\d+#/.test(after)) {
            Toaster.error(this.$t('shared.adjacentVariablesNotAllowed').toString());
            return;
        }

        const updatedContent = `${before}#Var${nextIndex}#${after}`;

        this.setTemplateContentWithMutation(updatedContent);

        this.ensureVariableExampleCount(nextIndex);

        this.ensureVariableMaxLengthCount(nextIndex);

        const defaultExample = TemplateVariableValidation.sanitizeExampleForType(
            this.getDefaultVariableExampleValue(nextIndex),
            'Letters & Numbers',
        );
        this.$set(
            this.templateVariableExamples,
            nextIndex - 1,
            defaultExample,
        );

        this.$set(this.templateVariableMaxLengths, nextIndex - 1, 0);
        this.$set(this.templateVariableTypes, nextIndex - 1, 'Letters & Numbers');

        this.$nextTick(() => {
            if (textarea) {
                const newCursorPos = cursorPos + `#Var${nextIndex}#`.length;
                textarea.setSelectionRange(newCursorPos, newCursorPos);
            }
        });

    }



    public deleteVariable(index: number) {
        if (this.areVariableActionsDisabled) return;

        this.templateVariableExamples.splice(index - 1, 1);
        this.templateVariableMaxLengths.splice(index - 1, 1);
        this.templateVariableTypes.splice(index - 1, 1);

        let content = this.model.templateContent || '';

        content = content.replace(new RegExp(`#Var${index}#`, 'gi'), '');

        let currentMax = this.templateVariableExamples.length + 1;
        for (let i = index + 1; i <= currentMax; i++) {
            content = content.replace(new RegExp(`#Var${i}#`, 'gi'), `#Var${i - 1}#`);
        }

        this.setTemplateContentWithMutation(content);
    }



    public getVariableExample(index: number): string {

        return this.templateVariableExamples[index - 1] || '';

    }



    public setVariableExample(index: number, value: string) {

        this.ensureVariableExampleCount(index);

        let truncated = value;
        const enteredMaxLength = this.templateVariableMaxLengths[index - 1];
        const maxExampleLength = enteredMaxLength && enteredMaxLength > 0
            ? enteredMaxLength
            : this.maxLengthInputMax;
        if (maxExampleLength !== undefined && truncated.length > maxExampleLength) {
            truncated = truncated.substring(0, maxExampleLength);
        }

        this.$set(this.templateVariableExamples, index - 1, truncated);
    }

    public onVariableExampleInput(index: number, event: Event) {
        const target = event.target as HTMLInputElement;
        if (!target) {
            return;
        }
        const sanitized = TemplateVariableValidation.sanitizeExampleForType(target.value, this.getVariableType(index));
        this.setVariableExample(index, sanitized);
        const stored = this.getVariableExample(index);
        if (target.value !== stored) {
            target.value = stored;
        }
    }

    public getVariableMaxLength(index: number): number | string {
        const value = this.templateVariableMaxLengths[index - 1];
        if (!value || value < 1) {
            return '';
        }
        return value;
    }

    public setVariableMaxLength(index: number, value: number) {
        this.ensureVariableMaxLengthCount(index);
        let clamped = Math.floor(value);
        if (isNaN(clamped) || clamped < 1) {
            this.$set(this.templateVariableMaxLengths, index - 1, 0);
            return;
        }
        const max = this.maxLengthInputMax;
        if (max !== undefined && clamped > max) {
            clamped = max;
        }
        this.$set(this.templateVariableMaxLengths, index - 1, clamped);
    }

    public onMaxLengthInput(index: number, event: Event) {
        const target = event.target as HTMLInputElement;
        if (!target || target.value === '') {
            this.setVariableMaxLength(index, 0);
            return;
        }
        const parsed = parseInt(target.value, 10);
        this.setVariableMaxLength(index, isNaN(parsed) ? 0 : parsed);
        const stored = String(this.getVariableMaxLength(index));
        if (target.value !== stored) {
            target.value = stored;
        }
    }

    private ensureVariableMaxLengthCount(index: number) {
        while (this.templateVariableMaxLengths.length < index) {
            this.templateVariableMaxLengths.push(0);
        }
    }

    public getVariableType(index: number): string {
        return this.templateVariableTypes[index - 1] || '';
    }

    public setVariableType(index: number, value: string) {
        this.ensureVariableTypeCount(index);
        this.$set(this.templateVariableTypes, index - 1, value);
        const example = this.getVariableExample(index);
        const sanitized = TemplateVariableValidation.sanitizeExampleForType(example, value);
        if (sanitized !== example) {
            this.setVariableExample(index, sanitized);
        }
    }

    private ensureVariableTypeCount(index: number) {
        while (this.templateVariableTypes.length < index) {
            this.templateVariableTypes.push('');
        }
    }

    public get hasMissingVariableTypes(): boolean {
        return this.templateVariableExamples.length > 0
            && (this.templateVariableTypes.length !== this.templateVariableExamples.length
                || this.templateVariableTypes.some((t) => !t));
    }

    public get variableTypeOptions(): Array<{value: string; label: string}> {
        return [
            { value: 'Numbers', label: this.$t('shared.variableTypeNumbers').toString() },
            { value: 'Letters', label: this.$t('shared.variableTypeLetters').toString() },
            { value: 'Letters & Numbers', label: this.$t('shared.variableTypeLettersAndNumbers').toString() },
            { value: 'Link', label: this.$t('shared.variableTypeLink').toString() },
        ];
    }

    public get hasSupportingDocumentAttachment(): boolean {
        return this.model.senderRequestAttachments.some(
            (a) => a.attachmentType === AttachmentCategoryType.SupportingDocument && !a.isDeleted,
        );
    }

    public get canUseGovernmentVariableException(): boolean {
        return this.model.customerType === 1 && this.hasSupportingDocumentAttachment;
    }

    public get maxLengthUpperBound(): number {
        return TemplateVariableValidation.maxLengthUpperBound;
    }

    public get maxLengthInputMax(): number | undefined {
        if (this.canUseGovernmentVariableException) {
            return undefined;
        }
        return TemplateVariableValidation.maxLengthUpperBound;
    }

    public get hasAdjacentVariables(): boolean {
        return /#Var\d+#\s*#Var\d+#/i.test(this.model.templateContent || '');
    }

    public get exceedsMaxVariableCount(): boolean {
        if (this.canUseGovernmentVariableException) {
            return false;
        }
        return this.templateVariableExamples.length > TemplateVariableValidation.maxVariableCount;
    }

    public get hasMaxLengthExceedingLimit(): boolean {
        if (this.canUseGovernmentVariableException) {
            return false;
        }
        return this.templateVariableMaxLengths.some((ml) => ml > TemplateVariableValidation.maxLengthUpperBound);
    }

    public get variableRatioPercent(): number {
        if (!this.templateVariableExamples.length) return 0;
        const totalMaxLength = TemplateVariableValidation.sumMaxLengths(this.templateVariableMaxLengths);
        const textContentLength = this.getTemplateContentWithoutVariables(this.fullTemplateContent).length;
        return TemplateVariableValidation.getDisplayRatioPercent(totalMaxLength, textContentLength);
    }

    public get exceeds40Percent(): boolean {
        if (!this.templateVariableExamples.length) return false;
        const totalMaxLength = TemplateVariableValidation.sumMaxLengths(this.templateVariableMaxLengths);
        const textContentLength = this.getTemplateContentWithoutVariables(this.fullTemplateContent).length;
        return TemplateVariableValidation.exceedsMaxRatio(totalMaxLength, textContentLength);
    }

    public get hasMissingMaxLength(): boolean {
        return this.templateVariableExamples.length > 0
            && (this.templateVariableMaxLengths.length !== this.templateVariableExamples.length
                || this.templateVariableMaxLengths.some((ml) => !ml || ml < 1));
    }

    public get hasEmptyVariableExamples(): boolean {
        return TemplateVariableValidation.hasEmptyExamples(this.templateVariableExamples);
    }

    public get hasMaxLengthLessThanExample(): boolean {
        return this.templateVariableExamples.some((example, index) => {
            const ml = this.templateVariableMaxLengths[index];
            return example && example.trim() && ml && ml < example.trim().length;
        });
    }

    public get maxLengthLessThanExampleLength(): number {
        for (let i = 0; i < this.templateVariableExamples.length; i++) {
            const example = this.templateVariableExamples[i];
            const ml = this.templateVariableMaxLengths[i];
            if (example && example.trim() && ml && ml < example.trim().length) {
                return example.trim().length;
            }
        }
        return 0;
    }

    public get hasVariableExampleTypeMismatch(): boolean {
        return this.templateVariableExamples.some((example, index) => {
            const type = this.templateVariableTypes[index];
            return !!example && !!type && !TemplateVariableValidation.isExampleValidForType(example, type);
        });
    }

    public get hasZeroTextContentWithVariables(): boolean {
        return this.hasTemplateVariables && this.templateContentTotalCharacterCount === 0;
    }

    public get variableValidationErrors(): string[] {
        const errors: string[] = [];
        if (this.hasAdjacentVariables) {
            errors.push(this.$t('shared.adjacentVariablesNotAllowed').toString());
        }
        if (this.exceedsMaxVariableCount) {
            errors.push(this.$t('shared.maxVariableCountExceeded', {
                count: TemplateVariableValidation.maxVariableCount,
            }).toString());
        }
        if (this.hasEmptyVariableExamples) {
            errors.push(this.$t('shared.variableExamplesRequired').toString());
        }
        if (this.hasMissingVariableTypes) {
            errors.push(this.$t('shared.variableTypeRequired').toString());
        }
        if (this.hasVariableExampleTypeMismatch) {
            errors.push(this.$t('shared.variableExampleTypeMismatch').toString());
        }
        if (this.hasZeroTextContentWithVariables) {
            errors.push(this.$t('shared.textContentRequiredWhenVariablesPresent').toString());
        }
        if (this.hasMaxLengthExceedingLimit) {
            errors.push(this.$t('shared.maxLengthExceeded', {
                max: TemplateVariableValidation.maxLengthUpperBound,
            }).toString());
        }
        if (this.hasMissingMaxLength) {
            errors.push(this.$t('shared.maxLengthRequired', {
                max: TemplateVariableValidation.maxLengthUpperBound,
            }).toString());
        }
        if (this.hasMaxLengthLessThanExample) {
            errors.push(this.$t('shared.maxLengthLessThanExample', {
                length: this.maxLengthLessThanExampleLength,
            }).toString());
        }
        if (this.exceeds40Percent) {
            errors.push(this.$t('shared.variablesMustNotExceed40Percent').toString());
        }
        return errors;
    }



    private ensureVariableExampleCount(index: number) {

        while (this.templateVariableExamples.length < index) {

            this.templateVariableExamples.push('');

        }

    }



    public onPickFile() {
        if (!this.canUploadMoreLicenseAttachments) {
            Toaster.error(this.$t('shared.maxLicenseAttachments').toString());
            return;
        }
        (this.$refs.fileName as HTMLInputElement).click();
    }

    private isPdfFile(file: File): boolean {
        return file.type === 'application/pdf' || file.name.toLowerCase().endsWith('.pdf');
    }

    public onFilePicked(event: Event) {
        const input = event.target as HTMLInputElement;
        const files = input.files;
        if (!files || !files.length) {
            return;
        }
        const file = files[0];
        if (!this.isPdfFile(file)) {
            Toaster.error(this.$t('shared.pdfFilesOnly').toString());
            input.value = '';
            this.selectedFileName = '';
            return;
        }
        if (file.size > this.maxLicenseFileSizeBytes) {
            Toaster.error(this.$t('shared.fileSizeExceedsTheLimit').toString());
            input.value = '';
            this.selectedFileName = '';
            return;
        }
        this.selectedFileName = file.name;
        this.currentAttachment.file = file;
        const reader = new FileReader();
        reader.onloadend = (fileData: ProgressEvent<FileReader>) => {
            const result = fileData.target && fileData.target.result;
            if (typeof result === 'string') {
                this.currentAttachment.fileContent = result.split(',')[1];
                this.currentAttachment.fileName = file.name;
            }
        };
        reader.readAsDataURL(file);
        input.value = '';
    }

    public addAttachment() {
        if (!this.canUploadMoreLicenseAttachments) {
            Toaster.error(this.$t('shared.maxLicenseAttachments').toString());
            return;
        }
        this.currentAttachment.attachmentType = AttachmentCategoryType.SupportingDocument;
        this.currentAttachment.attachmentTypeName = this.$t('shared.supportingDocument').toString();
        this.model.senderRequestAttachments.push({ ...this.currentAttachment });
        this.currentAttachment = {
            id: '',
            fileName: '',
            fileContent: '',
            file: null,
            attachmentType: '',
            attachmentTypeName: '',
            isDeleted: false,
        };
        this.selectedFileName = '';
        if (this.fileNameRef) {
            this.fileNameRef.value = '';
        }
    }

    public deleteAttachment(index: number) {
        this.model.senderRequestAttachments.splice(index, 1);
    }



    public get isValidApply(): boolean {

        const needsCr = this.model.customerType !== 3;

        const hasCr = this.model.crNumber.trim() !== '';

        const unifiedValid =

            (this.model.customerType === 2 || this.model.customerType === 3)

                ? this.model.enterpriseUnifiedNumber.trim() !== ''

                : true;

        return (

            this.model.customerType !== 0 &&

            (!needsCr || hasCr) &&

            unifiedValid

        );

    }


   



    public get filteredSenderNames(): SenderViewModel[] {

        const term = this.senderNameFilter.trim().toLowerCase();

        if (!term) {

            return this.allSenderNames;

        }

        return this.allSenderNames.filter((sender) =>

            sender.senderName && sender.senderName.toLowerCase().includes(term));

    }



    public async apply() {

        const response = await this.connectingSenderNameService

            .ConnectingSenderName('', this.model.crNumber, this.model.customerType, this.model.enterpriseUnifiedNumber);

        const senderResults = response && (response.result || response.Result);

        if (response && response.isSuccess && senderResults && senderResults.length) {

            this.allSenderNames = senderResults.map((name: any) => this.normalizeSenderViewModel(name));

            this.selected = [];

            this.selectedIds = [];

            this.model.classification = 0;

        } else {

            this.allSenderNames = [];

            this.selected = [];

            this.selectedIds = [];

            Toaster.error(this.$t('shared.dataNotFound').toString());

        }

    }



    public cancel() {

        this.$router.push('/MessageTemplateDashboard');

    }



    private resetTemplateCheck() {

        this.responseMessage = '';

        this.responseSuccess = false;

        this.isAiValid = false;

    }



    public reset() {

        this.model = {

            duration: '1',

            startDate: '',

            clientName: '',

            crNumber: '',

            enterpriseUnifiedNumber: '',

            customerType: 0,

            senderNames: [],

            requestType: 7,

            comment: '',

            expiryDate: '',

            templateExpiry: 1,

            templateName: '',

            templateDescription: '',

            templateContent: '',

            isNormalProcessing: true,

            isExpressProcessing: false,

        preApprovedTemplateId: '',

        senderId: '',

        classification: 0,
        companyName: '',
        senderRequestAttachments: [],
        selectedTemplateId: '',
        senderExpiryDate: '',

    };

        this.senderNameFilter = '';

        this.allSenderNames = [];

        this.selected = [];

        this.selectedIds = [];

        this.isSubmitted = false;

        this.stepNumber = 1;

        this.templateVariableExamples = [];
        this.templateVariableMaxLengths = [];
        this.templateVariableTypes = [];
        this.lastValidatedTemplateContent = '';
        this.lastEditableTemplateContent = '';
        this.lastAiFailureRemarks = '';
        this.selectedFileName = '';
        this.currentAttachment = {
            id: '',
            fileName: '',
            fileContent: '',
            file: null,
            attachmentType: '',
            attachmentTypeName: '',
            isDeleted: false,
        };
        this.aiValidationRemarks = '';

        this.preApprovedTemplates = [];

        this.endAiValidationLoading(false);

        this.resetTemplateCheck();

    }



    @Watch('model.customerType', { deep: true })

    public onchangeCustomerType() {

        if (this.provider.isVirtualOperator) {
            this.model.customerType = 3;
        }

        this.model.crNumber = '';

        this.model.senderNames = [];

        this.model.enterpriseUnifiedNumber = '';

        this.allSenderNames = [];

        this.senderNameFilter = '';

        this.selected = [];

        this.selectedIds = [];

        VirtualOperatorRules.applyPrivateClientFields(this.model, this.provider, false);

        switch (this.model.customerType) {

            case 1:

                this.senderTypeList = [

                    { id: SenderType.Advertisement, name: this.$t('shared.advertisement').toString() },

                    { id: SenderType.Service, name: this.$t('shared.service').toString() },

                    { id: SenderType.Awareness, name: this.$t('shared.awareness').toString() },

                    { id: SenderType.Warning, name: this.$t('shared.warning').toString() },

                ];

                break;

            case 2:

            case 3:

                this.senderTypeList = [

                    { id: SenderType.Advertisement, name: this.$t('shared.advertisement').toString() },

                    { id: SenderType.Service, name: this.$t('shared.service').toString() },

                    { id: SenderType.Awareness, name: this.$t('shared.awareness').toString() },

                ];

                break;

            case 4:

                this.senderTypeList = [

                    { id: SenderType.Service, name: this.$t('shared.service').toString() },

                ];

                break;

        }

    }



    @Watch('senderNameFilter')

    public onSenderNameFilterChange() {

        if (this.selectedIds.length === 0) {

            return;

        }

        const visibleIds = this.filteredSenderNames.map((s) => s.id);

        if (!this.selectedIds.every((id) => visibleIds.includes(id))) {

            this.selected = [];

            this.selectedIds = [];

        }

    }



    @Watch('model.preApprovedTemplateId')
    public onSuggestedFreeContentChanged(preApprovedTemplateId: string) {
        if (!preApprovedTemplateId) {
            this.model.selectedTemplateId = '';
            this.model.templateContent = '';
            this.templateVariableExamples = [];
            this.templateVariableMaxLengths = [];
            this.templateVariableTypes = [];
            this.lastValidatedTemplateContent = '';
            this.lastEditableTemplateContent = '';
            this.lastAiFailureRemarks = '';
            this.aiValidationRemarks = '';
            this.resetTemplateCheck();
        }
    }



    @Watch('model.classification')
    public onClassificationChanged(newClassification: number, oldClassification: number) {
        if (oldClassification && newClassification !== oldClassification && this.isSuggestedFreeContentSelected) {
            this.deselectSuggestedTemplate();
        }
        if (newClassification !== 5) {
            this.model.companyName = '';
        }
        this.loadPreApprovedTemplates(newClassification);
    }

    private async loadPreApprovedTemplates(classification: number) {
        if (!classification) {
            this.preApprovedTemplates = [];
            return;
        }
        this.loadingPreApprovedTemplates = true;
        try {
            const response = await this.messageTemplateService.getPreApprovedTemplates(classification);
            if (response && response.isSuccess && response.result) {
                this.preApprovedTemplates = (response.result || []).map((item: any) => {
                    let contentText = '';
                    let variables: string[] = [];
                    let maxLengths: number[] = [];
                    let types: string[] = [];
                    let rawContent = item.templateContent || item.TemplateContent || '';
                    if (rawContent) {
                        try {
                            let parsed = JSON.parse(rawContent);
                            contentText = parsed.text || rawContent;
                            variables = parsed.variables || [];
                            maxLengths = parsed.maxLengths || [];
                            types = parsed.types || [];
                        } catch {
                            contentText = rawContent;
                        }
                    }
                    return {
                        id: item.id || item.Id,
                        templateCode: item.templateCode || item.TemplateCode || '',
                        classification: item.classification || item.Classification,
                        name: item.name || item.Name,
                        description: item.description || item.Description || '',
                        content: contentText,
                        variableExamples: variables,
                        variableMaxLengths: maxLengths,
                        variableTypes: types,
                    };
                });
            } else {
                this.preApprovedTemplates = [];
            }
        } catch {
            this.preApprovedTemplates = [];
        } finally {
            this.loadingPreApprovedTemplates = false;
        }
    }



    @Watch('selectedIds')

    public onSelectedSenderChanged() {

        const allowedIds = this.filteredClassifications.map((item) => item.id);

        if (this.model.classification && !allowedIds.includes(this.model.classification)) {

            this.model.classification = 0;

        }

    }



    @Watch('model.isExpressProcessing')
    public onExpressProcessingChanged(isExpress: boolean) {
        this.model.isNormalProcessing = !isExpress;
    }

    @Watch('model.templateContent')
    public onTemplateContentChanged(newContent: string) {

        if (this.isTemplateContentMutationAllowed || this.isSuggestedFreeContentSelected) {

            this.lastEditableTemplateContent = newContent || '';

            this.syncAiRemarksForContentEdit(newContent);

            return;

        }

        const previousContent = this.lastEditableTemplateContent || this.lastValidatedTemplateContent || '';

        const previousVariables = this.extractVariablePlaceholders(previousContent);

        const nextVariables = this.extractVariablePlaceholders(newContent || '');

        const variablesPreserved = previousVariables.length === nextVariables.length
            && previousVariables.every((token, index) => token.toLowerCase() === (nextVariables[index] || '').toLowerCase())
            && previousVariables.every((token) => (newContent || '').includes(token));

        if (!variablesPreserved) {

            this.isTemplateContentMutationAllowed = true;

            this.model.templateContent = previousContent;

            this.$nextTick(() => {

                this.isTemplateContentMutationAllowed = false;

            });

            return;

        }

        this.lastEditableTemplateContent = newContent || '';

        this.syncAiRemarksForContentEdit(newContent);

    }

    private syncAiRemarksForContentEdit(newContent: string): void {

        if ((newContent || '') !== this.lastValidatedTemplateContent) {

            this.aiValidationRemarks = '';

            return;

        }

        if (this.lastAiFailureRemarks) {

            this.aiValidationRemarks = this.lastAiFailureRemarks;

        }

    }

    @Watch('stepNumber')

    public onStepChanged(newStep: number) {

        if (newStep === 2 && this.isExpressProcessingHidden) {

            this.model.isExpressProcessing = false;
            this.model.isNormalProcessing = true;

        }

        if (newStep === 2) {

            this.lastValidatedTemplateContent = this.model.templateContent || '';
            this.lastEditableTemplateContent = this.model.templateContent || '';

        }

        if (newStep === 1) {

            this.$nextTick(() => this.syncSelectedSender());

        }

    }



    private syncSelectedSender(): void {

        const selectedId = this.selectedIds[0] || this.model.senderId;

        if (!selectedId || !this.allSenderNames.length) {

            return;

        }

        const item = this.allSenderNames.find((sender) => sender.id === selectedId);

        if (!item) {

            this.selected = [];

            this.selectedIds = [];

            return;

        }

        this.selected = [item];

        this.selectedIds = [selectedId];

        this.model.senderId = selectedId;

        this.model.senderNames = [item];

        this.model.clientName = item.clientName;

        this.syncSenderExpiryDate(item);

    }



    public showsubmitRequestDialog() {

        this.submitRequestdialog = true;

    }



    public hidesubmitRequestDialog() {

        this.submitRequestdialog = false;

    }



    public async submitRequest() {

        this.model.senderNames = this.selected;

        this.model.clientName = this.selected[0].clientName;

        this.model.senderId = this.selected[0].id;



        const payload = {

            TemplateName: this.model.templateName,

            TemplateDescription: this.model.templateDescription || '',

            TemplateContent: JSON.stringify({ text: this.fullTemplateContent, variables: this.templateVariableExamples, maxLengths: this.hasTemplateVariables ? this.templateVariableMaxLengths : [], types: this.hasTemplateVariables ? this.templateVariableTypes : [] }),

            SenderId: this.model.senderId,

            Classification: this.model.classification,
            CompanyName: this.model.companyName || '',
            IsExpressProcessing: this.isPaymentPhaseEnabled ? this.model.isExpressProcessing : false,

            PreApprovedTemplateId: this.model.preApprovedTemplateId || null,
            SenderRequestAttachments: this.model.senderRequestAttachments.map((attachment) => ({
                FileName: attachment.fileName,
                FileContent: attachment.fileContent,
                AttachmentType: attachment.attachmentType,
                IsDeleted: false,
            })),
        };



        const response = await this.connectingSenderNameService.post(payload);

        if (response.isSuccess) {

            this.isSubmitted = true;

        } else {

            const errorMessage = response && response.errorMessage ? response.errorMessage : '';
            Toaster.error(errorMessage === this.templateExpiryExceedsSenderExpiryMessage
                ? this.$t('shared.templateExpiryExceedsSenderExpiry').toString()
                : errorMessage);

        }

        this.hidesubmitRequestDialog();

    }



    public newRequest() {

        this.reset();

    }

    public goToDashboard() {
        this.$router.push('/MessageTemplateDashboard');
    }



    private getTemplateValidationErrorMessage(response: any, axiosError?: AxiosError): string {

        const responseReason = response && response.result ? response.result.reason : '';

        const responseErrorMessage = response ? (response.errorMessage || response.ErrorMessage || '') : '';

        const apiErrorData: any = axiosError && axiosError.response ? axiosError.response.data : null;

        const apiErrorMessage = apiErrorData ? (apiErrorData.errorMessage || apiErrorData.ErrorMessage || apiErrorData.message || '') : '';



        const rawMessage = (responseReason || responseErrorMessage || apiErrorMessage || '').toString();

        if (!rawMessage) {

            return this.$t('shared.unexpectedError').toString();

        }



        if (rawMessage.toLowerCase().indexOf(this.noActiveRegulationMessage.toLowerCase()) !== -1) {

            return this.$t('shared.noActiveRegulationFoundForThisCategory').toString();

        }



        return rawMessage;

    }



    private startAiValidationLoading(): void {

        this.loadingAIValidation = true;

        this.aiValidationProgress = 0;

        clearInterval(this.aiValidationProgressInterval);

        this.aiValidationProgressInterval = setInterval(() => {

            if (this.aiValidationProgress < 98) {

                this.aiValidationProgress += 1;

            }

        }, 300);

    }

    private endAiValidationLoading(forceTo100: boolean): void {

        clearInterval(this.aiValidationProgressInterval);

        if (forceTo100) {

            this.aiValidationProgress = 100;

        }

        this.loadingAIValidation = false;

    }

    public showAiContinueDialog() {
        this.aiContinueDialog = true;
    }

    public hideAiContinueDialog() {
        this.aiContinueDialog = false;
    }

    public confirmAiContinue() {
        this.hideAiContinueDialog();
        this.stepNumber = 3;
    }

    public cancelAiContinue() {
        this.hideAiContinueDialog();
    }

    private async runAiValidation(): Promise<boolean> {

        this.startAiValidationLoading();

        try {

            return await this.checkMessageTemplate();

        } finally {

            this.endAiValidationLoading(true);

        }

    }

    async checkMessageTemplate(): Promise<boolean> {

        this.responseMessage = '';

        this.responseSuccess = false;

        this.isAiValid = false;

        this.aiValidationRemarks = '';



        try {

            this.validationModel.TemplateContent = (this.model.templateContent || '').trim();

            this.validationModel.Classification = this.model.classification;



            const response = await this.messageTemplateService.checkMessageTemplate(this.validationModel);

            this.lastValidatedTemplateContent = this.model.templateContent || '';
            this.lastEditableTemplateContent = this.model.templateContent || '';

            if (response.isSuccess) {

                if (response.result.valid === true) {

                    this.responseSuccess = true;

                    this.isAiValid = true;

                    this.aiValidationRemarks = '';

                    this.lastAiFailureRemarks = '';

                    Toaster.success(this.$t('shared.templateValid').toString());

                    return true;

                }

                this.responseSuccess = false;

                this.isAiValid = false;

                this.responseMessage = response.result.reason;

                this.aiValidationRemarks = response.result.reason
                    || this.$t('shared.templateInvalid').toString();

                this.lastAiFailureRemarks = this.aiValidationRemarks;

                Toaster.error(this.$t('shared.aiCheckFailed').toString());

                return false;

            }

            this.responseSuccess = false;

            this.isAiValid = false;

            this.responseMessage = this.getTemplateValidationErrorMessage(response);

            this.aiValidationRemarks = this.responseMessage;

            this.lastAiFailureRemarks = this.aiValidationRemarks;

            Toaster.error(this.$t('shared.aiCheckFailed').toString());

            return false;

        } catch (error) {

            const axiosError = error as AxiosError;

            this.responseSuccess = false;

            this.isAiValid = false;

            this.responseMessage = this.getTemplateValidationErrorMessage(null, axiosError);

            this.aiValidationRemarks = this.responseMessage;

            this.lastAiFailureRemarks = this.aiValidationRemarks;

            Toaster.error(this.$t('shared.aiCheckFailed').toString());

            return false;

        }

    }



    selectOne(event: any, id: string) {

        const item = this.allSenderNames.find((a) => a.id === id);

        this.selected = [];



        if (event && item) {

            this.selected.push(item);

            this.selectedIds = [id];

            this.model.senderId = id;

            this.model.senderNames = [item];

            this.model.clientName = item.clientName;

            this.syncSenderExpiryDate(item);

        } else {

            this.selectedIds = [];

            this.model.senderId = '';

            this.model.senderNames = [];

            this.model.senderExpiryDate = '';

        }

    }



    public getCustomerTypeText(typeId: number) {

        switch (typeId) {

            case 1: return this.$t('shared.government').toString();

            case 2: return this.$t('shared.charity').toString();

            case 3: return this.$t('shared.private').toString();

            case 4: return this.$t('shared.international').toString();

            default: return '-';

        }

    }



    public getClassificationText(typeId: number) {

        const item = this.allClassifications.find((c) => c.id === typeId);

        return item ? item.name : '-';

    }

    public get selectedSender(): SenderViewModel | null {

        if (this.selected.length) {

            return this.selected[0];

        }

        const selectedId = this.selectedIds[0] || this.model.senderId;

        if (!selectedId || !this.allSenderNames.length) {

            return null;

        }

        return this.allSenderNames.find((sender) => sender.id === selectedId) || null;

    }

    public get referenceNumber(): string {
        const crNumber = (this.model.crNumber || '').trim();
        const enterpriseUnifiedNumber = (this.model.enterpriseUnifiedNumber || '').trim();

        if (crNumber) {
            return crNumber;
        }

        if (enterpriseUnifiedNumber) {
            return enterpriseUnifiedNumber;
        }

        return '-';
    }

    public get selectedSenderTypesText(): string {
        const sender = this.selectedSender;

        if (!sender || !sender.senderTypes.length) {
            return '-';
        }

        return sender.senderTypes
            .map((type, index) => {
                const label = this.getSenderTypeText(type);
                return index < sender.senderTypes.length - 1 ? `${label} /` : label;
            })
            .join(' ');
    }

    public get selectedSenderExpiryDate(): string {

        const sender = this.selectedSender;

        const expiry = (sender && sender.senderExpiryDate) || this.model.senderExpiryDate;

        return this.formatSenderExpiryDate(expiry) || '-';

    }

    public get selectedTemplateExpiryDate(): string {

        const sender = this.selectedSender;

        const expiry = sender && sender.templateExpiryDate ? sender.templateExpiryDate : '';

        return this.formatSenderExpiryDate(expiry) || '-';

    }

    private isTemplateExpiryWithinSenderExpiry(): boolean {

        const sender = this.selectedSender;

        if (!sender || !sender.templateExpiryDate || !sender.senderExpiryDate) {
            return true;
        }

        return sender.templateExpiryDate <= sender.senderExpiryDate;

    }

    private formatSenderExpiryDate(value?: string): string {

        if (!value) {

            return '';

        }

        const text = String(value).trim();

        if (!text) {

            return '';

        }

        const isoDate = text.split('T')[0];

        if (/^\d{4}-\d{2}-\d{2}$/.test(isoDate)) {

            return isoDate;

        }

        const parsed = new Date(text);

        if (!Number.isNaN(parsed.getTime())) {

            return parsed.toISOString().split('T')[0];

        }

        return text;

    }

    private resolveSenderExpiryDate(raw: any): string {

        const direct = raw.senderExpiryDate
            || raw.SenderExpiryDate
            || raw.expiryDate
            || raw.ExpiryDate;

        return this.formatSenderExpiryDate(direct);

    }

    private normalizeSenderViewModel(raw: any): SenderViewModel {
        const sender: SenderViewModel = {
            id: raw.id || raw.Id || '',
            senderName: raw.senderName || raw.SenderName || '',
            clientName: raw.clientName || raw.ClientName || '',
            senderType: raw.senderType != null ? raw.senderType : raw.SenderType,
            senderTypes: [],
            startDate: raw.startDate || raw.StartDate,
            duration: raw.duration != null ? raw.duration : raw.Duration,
            senderExpiryDate: this.resolveSenderExpiryDate(raw),
            templateExpiryDate: this.formatSenderExpiryDate(raw.templateExpiryDate || raw.TemplateExpiryDate),
        };

        this.getSenderType(sender.senderType, sender);

        return sender;
    }

    private syncSenderExpiryDate(sender: SenderViewModel | null): void {

        this.model.senderExpiryDate = sender && sender.senderExpiryDate ? sender.senderExpiryDate : '';

    }



    public getSenderType(type: number, sender: SenderViewModel) {

        sender.senderTypes = [];

        const senderBinary = type;

        if ((senderBinary & 1) === 1) sender.senderTypes.push(1);

        if ((senderBinary & 2) === 2) sender.senderTypes.push(2);

        if ((senderBinary & 4) === 4) sender.senderTypes.push(4);

        if ((senderBinary & 8) === 8) sender.senderTypes.push(8);

    }



    public getSenderTypeText(typeId: number) {

        switch (typeId) {

            case SenderType.Advertisement: return this.$t('shared.advertisement').toString();

            case SenderType.Service: return this.$t('shared.service').toString();

            case SenderType.Awareness: return this.$t('shared.awareness').toString();

            case SenderType.Warning: return this.$t('shared.warning').toString();

            default: return '-';

        }

    }



    public get isValidStep(): boolean {
        if (this.stepNumber === 1) {
            return this.selectedIds.length !== 0;
        }
        if (this.stepNumber === 2) {
            const nameValid = this.model.templateName.trim() !== '';
            const classificationValid = this.model.classification !== 0;
            const companyNameValid = this.model.classification !== 5 || (this.model.companyName || '').trim() !== '';

            if (this.isSuggestedFreeContentSelected) {
                return nameValid
                    && classificationValid
                    && companyNameValid
                    && this.isTemplateDescriptionValid
                    && !!this.model.selectedTemplateId
                    && this.areVariableExamplesValid;
            }

            const areVariablesValid = this.areVariableExamplesValid;
            const noVariableErrors = !this.hasTemplateVariables || this.variableValidationErrors.length === 0;

            return nameValid
                && classificationValid
                && companyNameValid
                && this.isTemplateDescriptionValid
                && this.model.templateContent.trim() !== ''
                && this.templateContentTotalCharacterCount >= this.templateContentMinimumCharacterCount
                && !this.hasInvalidVariableBoundary
                && areVariablesValid
                && noVariableErrors;
        }
        return true;
    }
}

